<template>
  <a-modal
    :visible="visible"
    :title="title"
    :confirm-loading="confirmLoading"
    :width="1000"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="要货单" prop="purchaseOrderId">
        <a-select
          v-model="form.purchaseOrderId"
          placeholder="请选择要货单"
          show-search
          :filter-option="filterOption"
          @change="handlePurchaseOrderChange"
        >
          <a-select-option v-for="item in purchaseOrders" :key="item.id" :value="item.id">
            {{ item.orderNo }} - {{ item.storeName }} (¥{{ item.applyAmount }})
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="退货明细" prop="items">
        <a-table
          :columns="itemColumns"
          :data-source="form.items"
          :row-key="record => record.purchaseItemId"
          :pagination="false"
          size="small"
          :scroll="{ x: 700 }"
        >
          <template slot="goodsInfo" slot-scope="text, record">
            <div>{{ record.goodsName }}</div>
            <div style="color: #999; font-size: 12px;">{{ record.skuName }}</div>
          </template>
          <template slot="applyCount" slot-scope="text">
            {{ text }}
          </template>
          <template slot="returnCount" slot-scope="text, record, index">
            <a-input-number
              v-model="record.returnCount"
              :min="0"
              :max="record.applyCount"
              :precision="0"
              style="width: 100%"
              placeholder="退货数量"
              @change="calculateReturnAmount(record)"
            />
          </template>
          <template slot="unitPrice" slot-scope="text">
            ¥{{ text }}
          </template>
          <template slot="returnAmount" slot-scope="text, record">
            <span :style="{ color: record.returnCount > 0 ? '#ff4d4f' : '' }">
              ¥{{ (record.unitPrice * record.returnCount).toFixed(2) }}
            </span>
          </template>
          <template slot="action" slot-scope="text, record, index">
            <a-button type="link" size="small" @click="handleDeleteItem(index)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-form-model-item>

      <a-form-model-item label="退货总金额">
        <span style="font-size: 18px; color: #ff4d4f; font-weight: bold;">¥{{ totalReturnAmount.toFixed(2) }}</span>
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" :rows="3" placeholder="请输入备注" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getPurchaseList } from '@/api/retail/purchase'
import { getPurchaseDetail } from '@/api/retail/purchase'
import { createPurchaseReturn } from '@/api/retail/purchase'

export default {
  name: 'CreateReturnForm',
  data() {
    return {
      visible: false,
      title: '创建退货单',
      confirmLoading: false,
      // 要货单列表
      purchaseOrders: [],
      // 表单
      form: {
        purchaseOrderId: undefined,
        items: [],
        remark: undefined
      },
      // 表单验证规则
      rules: {
        purchaseOrderId: [
          { required: true, message: '请选择要货单', trigger: 'change' }
        ],
        items: [
          { required: true, message: '请添加退货明细', trigger: 'change' }
        ]
      },
      // 明细列表表头
      itemColumns: [
        {
          title: '商品信息',
          dataIndex: 'goodsInfo',
          align: 'left',
          scopedSlots: { customRender: 'goodsInfo' },
          width: 220
        },
        {
          title: '申请数量',
          dataIndex: 'applyCount',
          align: 'center',
          width: 90
        },
        {
          title: '退货数量',
          dataIndex: 'returnCount',
          align: 'center',
          scopedSlots: { customRender: 'returnCount' },
          width: 130
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          align: 'center',
          scopedSlots: { customRender: 'unitPrice' },
          width: 90
        },
        {
          title: '退货金额',
          dataIndex: 'returnAmount',
          align: 'center',
          scopedSlots: { customRender: 'returnAmount' },
          width: 110
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 80,
          fixed: 'right'
        }
      ]
    }
  },
  computed: {
    // 退货总金额
    totalReturnAmount() {
      return this.form.items.reduce((total, item) => {
        return total + (item.unitPrice * item.returnCount || 0)
      }, 0)
    }
  },
  methods: {
    /**
     * 打开弹窗
     */
    handleAdd() {
      this.visible = true
      this.form = {
        purchaseOrderId: undefined,
        items: [],
        remark: undefined
      }
      this.loadPurchaseOrders()
    },

    /**
     * 加载已审核的要货单列表
     */
    loadPurchaseOrders() {
      getPurchaseList({
        orderStatus: 1, // 已审核
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        this.purchaseOrders = res.data.records
      })
    },

    /**
     * 要货单变化
     */
    handlePurchaseOrderChange(purchaseOrderId) {
      getPurchaseDetail({ orderId: purchaseOrderId }).then(res => {
        const order = res.data
        this.form.items = order.items.map(item => ({
          purchaseItemId: item.id,
          goodsId: item.goodsId,
          skuId: item.skuId,
          goodsName: item.goodsName,
          skuName: item.skuName,
          applyCount: item.applyCount,
          returnCount: 0,
          unitPrice: item.unitPrice || 0
        }))
      })
    },

    /**
     * 计算退货金额
     */
    calculateReturnAmount(record) {
      // 自动计算
    },

    /**
     * 删除明细项
     */
    handleDeleteItem(index) {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除该商品吗？',
        onOk: () => {
          this.form.items.splice(index, 1)
        }
      })
    },

    /**
     * 提交
     */
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 校验是否有退货数量
          const hasReturnCount = this.form.items.some(item => item.returnCount > 0)
          if (!hasReturnCount) {
            this.$message.warning('请至少输入退货数量')
            return
          }

          // 过滤掉退货数量为0的项
          const items = this.form.items
            .filter(item => item.returnCount > 0)
            .map(item => ({
              purchaseItemId: item.purchaseItemId,
              returnCount: item.returnCount
            }))

          const params = {
            purchaseOrderId: this.form.purchaseOrderId,
            items: items,
            remark: this.form.remark
          }

          this.confirmLoading = true
          createPurchaseReturn(params).then(() => {
            this.$message.success('创建成功')
            this.$emit('ok')
            this.handleCancel()
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },

    /**
     * 取消
     */
    handleCancel() {
      this.visible = false
      this.$refs.form.resetFields()
    },

    /**
     * 搜索过滤
     */
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
